import React from 'react';
import Image, { transparentDataImg } from '@jetshop/ui/Image/Image';
import { Link } from 'react-router-dom';
import { Above } from '@jetshop/ui/Breakpoints';
import { styled } from 'linaria/react';
import { theme } from '../../Theme';

const JournalPostsWrapper = styled('div')`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: auto;
  grid-column-gap: 20px;
  grid-row-gap: 20px;

  ${theme.below.lg} {
    display: flex;
    flex-direction: column;
  }
`;

const JournalPost = styled('div')`
  width: 100%;
  background: ${theme.colors.lightgrey};
  a {
    text-decoration: none;
    color: #000;
  }
`;

const FirstJournalPost = styled('div')`
  width: 100%;
  background: ${theme.colors.lightgrey};
  margin-bottom: 20px;
  a {
    color: #000;
    text-decoration: none;
  }
`;

const JournalPostContent = styled('div')`
  width: 100%;
  padding: 20px;

  &.first-post {
    width: 100%;
    padding: 30px 40px;

    h3 {
      font-size: 31px;
      line-height: 31px;
    }
  }

  h3 {
    font-weight: 500;
    font-size: 21px;
    line-height: 21px;
    color: #000000;
  }

  h4 {
    font-weight: 700;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #000000;
    margin-bottom: 20px;
  }
`;

//TODO behöver optimeras,
// co-pilot tycker följande
//sortAllPosts körs för varje render. Kanske använda useMemo? Eller bara sortera allPosts i useEffect? Eller kanske bara sortera allPosts i useEffect och inte i sortAllPosts?
export const JournalPostsList = ({ subCategories, activeSubCategory }) => {
  let allPosts = [];

  const sortAllPosts = () => {
    subCategories?.forEach(subCategory => {
      subCategory?.hasSubcategories &&
        subCategory?.subcategories?.forEach(post => {
          allPosts.push(post);
        });
    });
    allPosts.sort((a, b) => b.id - a.id);

    if (activeSubCategory !== 'all') {
      const filteredPosts = allPosts.filter(post => {
        return post?.parent?.name === activeSubCategory;
      });

      allPosts = filteredPosts;
    }
    return allPosts;
  };

  sortAllPosts();

  const imageSizes = [1, 1, 1, 1, 1];

  return (
    <div>
      <FirstJournalPost>
        <Above breakpoint="lg">
          {matches => (
            <Link to={allPosts?.[0]?.primaryRoute?.path}>
              {allPosts?.[0]?.images ? (
                <>
                  <Image
                    sizes={imageSizes}
                    aspect={matches ? '1210:345' : '390:204'}
                    alt="alt"
                    src={allPosts[0]?.images[4]?.url}
                    cover
                    critical={true}
                  />
                </>
              ) : (
                <Image
                  aspect={matches ? '1210:345' : '390:204'}
                  src={transparentDataImg}
                />
              )}
              <JournalPostContent className="first-post">
                <h4>{allPosts?.[0]?.parent?.name}</h4>
                <h3>{allPosts?.[0]?.name}</h3>
              </JournalPostContent>
            </Link>
          )}
        </Above>
      </FirstJournalPost>
      <JournalPostsWrapper>
        {allPosts?.map((post, index) => {
          return (
            index !== 0 && (
              <JournalPost>
                <Above breakpoint="lg">
                  {matches => (
                    <Link to={post?.primaryRoute?.path}>
                      {post?.images ? (
                        <>
                          <Image
                            sizes={imageSizes}
                            aspect={matches ? '390:345' : '390:204'}
                            alt="alt"
                            src={post?.images?.[4]?.url}
                            cover
                          />
                        </>
                      ) : (
                        <Image
                          aspect={matches ? '390:345' : '390:204'}
                          src={transparentDataImg}
                        />
                      )}
                      <JournalPostContent>
                        <h4>{post?.parent?.name}</h4>
                        <h3>{post?.name}</h3>
                      </JournalPostContent>
                    </Link>
                  )}
                </Above>
              </JournalPost>
            )
          );
        })}
      </JournalPostsWrapper>
    </div>
  );
};
